import { useLocation } from "react-router";
import { ARCHIVE_MODE } from "@/config/archive";
import { ArchiveInlineNotice } from "./ArchiveInlineNotice";

/** Routes that already explain the archive in full — no strip needed. */
const SUPPRESSED_PREFIXES = [
  "/archive",
  "/auth",
  "/qa",
  "/admin",
  "/dashboard",
  "/profile",
  "/employer",
  "/messages",
  "/applications",
  "/onboarding",
  "/checkout",
];

/** Browsable inventory — warn that the roles/companies are frozen and may be closed. */
const LISTING_PREFIXES = ["/jobs", "/companies", "/roles", "/salaries", "/salary", "/data-center-jobs"];

/** Editorial and guide content written while the platform was operating. */
const CONTENT_PREFIXES = ["/signal", "/learning", "/guides", "/vibe-coding", "/what-is-vibe-coding", "/glossary"];

const matches = (path: string, prefixes: string[]) =>
  prefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));

/**
 * Route-aware archive strip rendered once in the layout, so every public
 * surface carries the correct frozen-state wording without each page having
 * to remember it. The home page and the archive pages opt out — they carry
 * their own, fuller explanation.
 */
export const ArchiveRouteNotice = () => {
  const { pathname } = useLocation();

  if (!ARCHIVE_MODE) return null;
  if (pathname === "/") return null;
  if (matches(pathname, SUPPRESSED_PREFIXES)) return null;

  const tone = matches(pathname, LISTING_PREFIXES)
    ? "listing"
    : matches(pathname, CONTENT_PREFIXES)
      ? "content"
      : "page";

  return (
    <div className="container mx-auto px-4 pt-6">
      <ArchiveInlineNotice tone={tone} />
    </div>
  );
};

export default ArchiveRouteNotice;
